import { Observable } from 'rxjs';

export interface Country {
  type: string;
  name: string;
  region: string;
}

export interface JanuaryCountry {
  country: Country;
}
export interface FebraryCountry {
  country: Country;
}
export interface MarchCountry {
  country: Country;
}
export interface AprilCountry {
  country: Country;
}
export interface MayCountry {
  country: Country;
}
export interface JuneCountry {
  country: Country;
}
export interface JulyCountry {
  country: Country;
}
export interface AugustCountry {
  country: Country;
}
export interface SeptemberCountry {
  country: Country;
}
export interface OctoberCountry {
  country: Country;
}
export interface NovemberCountry {
  country: Country;
}
export interface DecemberCountry {
  country: Country;
}

export abstract class CalendarSearchData {
  abstract getJanuaryCountries(): Observable<JanuaryCountry[]>;
  abstract getFebraryCountries(): Observable<FebraryCountry[]>;
  abstract getMarchCountries(): Observable<MarchCountry[]>;
  abstract getAprilCountries(): Observable<AprilCountry[]>;
  abstract getMayCountries(): Observable<MayCountry[]>;
  abstract getJuneCountries(): Observable<JuneCountry[]>;
  abstract getJulyCountries(): Observable<JulyCountry[]>;
  abstract getAugustCountries(): Observable<AugustCountry[]>;
  abstract getSeptemberCountries(): Observable<SeptemberCountry[]>;
  abstract getOctoberCountries(): Observable<OctoberCountry[]>;
  abstract getNovemberCountries(): Observable<NovemberCountry[]>;
  abstract getDecemberCountries(): Observable<DecemberCountry[]>;

}
